import { render, staticRenderFns } from "./ModelDetails.vue?vue&type=template&id=0d2bfc31&scoped=true"
import script from "./ModelDetails.vue?vue&type=script&lang=js"
export * from "./ModelDetails.vue?vue&type=script&lang=js"
import style0 from "./ModelDetails.vue?vue&type=style&index=0&id=0d2bfc31&prod&lang=css"
import style1 from "./ModelDetails.vue?vue&type=style&index=1&id=0d2bfc31&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2bfc31",
  null
  
)

export default component.exports